export default __webpack_public_path__ + "static/media/insta.8b42420d.svg";